import { doc, getDoc } from 'firebase/firestore';
import { database } from '../../helper/firebase.helper';

export const getFormTemplate = async (formId) => {
  const formDocRef = doc(database, `intake_forms/${formId}`);
  try {
    const formDocSnap = await getDoc(formDocRef);
    if (formDocSnap.exists()) {
      return formDocSnap.data();
    } else {
      console.log('No such form template!');
      return null;
    }
  } catch (error) {
    console.log('Error fetching form template: ', error);
    return null;
  }
};

export const getClientFormAnswers = async (clientId, formId) => {
  const formDocRef = doc(database, `clients/${clientId}/intake_forms/${formId}`);
  try {
    const formDocSnap = await getDoc(formDocRef);
    if (!formDocSnap.exists()) {
      return null;
    }
    const data = formDocSnap.data();
    if (data.answers) {
      return data;
    }
    if (Array.isArray(data.questions)) {
      const answers = {};
      data.questions.forEach((q) => {
        if (q.id) {
          answers[q.id] = q.answer !== undefined ? q.answer : null;
        }
      });
      return {
        ...data,
        answers
      };
    }
    return data;
  } catch (error) {
    console.log('Error fetching client form answers: ', error);
    return null;
  }
};
